import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-fzunterklasse-list-view',
  imports: [],
  templateUrl: './fzunterklasse.list-view.html',
  styleUrls: ['./fzunterklasse.list-view.css'],
})
export class FzunterklasseListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
